
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        params: {
            type: Object as () => { value: any },
            required: true,
        },
    },
});
